<template>
  <div id="sovdetail">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
  	<div class="datepickerwrap">
  		<div class="leftcontent wrapitem">
  			<div class="datebox">
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate" />
  	 		</div>
  	 		<div class="datebox">
          <select v-model="selected_website" class="form-control text-uppercase">
          	<option value="https://www.amazon.com">Amazon</option>
          </select>
        </div>
        <div class="datebox" style="width:18%">
          <select  class="form-control text-uppercase">
            <option>Bluetooth Headphone</option>
          </select>
        </div>
  	 		<div class="datebox">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            <span style="font-size:13px">Submit</span>
          </button>
        </div>
  	 	</div>
       <div class="righcontent wrapitem">
        	<div class="datebox" style="float:right">
          <button @click="backToSov" style="width:max-content;float:right" class="btn btn-block weavrpurple" type="button">
            <i class="fa fa-arrow-left"></i>
            <span style="font-size:13px"> Back</span>
          </button>
        </div>
      </div>
  	</div>
    <div class="container-fluid ">
      <div class="">
        <div class="card p-2">
          <div class="amd-legend"> 
          
            <div class="legending">
              <i class="fa fa-circle" style="color: #ffb9b9!important"></i>
              <span>plantronics</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #c7e0ff!important"></i>
              <span>ptron</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #ffd0f5 !important"></i>
              <span>boat</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #edf2fb!important"></i>
              <span>zebronics</span>
            </div>
          </div>  
          <table id="myTable2" class="table table-striped table-bordered">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group;">
                <tr>
                  <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
                </tr>
              </tfoot> 
            <tbody class="tbody-normal" > 
              <tr v-for="(r,i) in rows_details"  :key="i" :class="{'markitamd':r['brand'] == 'plantronics',
                'markitintel':r['brand'] == 'ptron','markitsnap':r['brand'] == 'boat','markitna':r['brand'] == 'zebronics'}">
                <td v-for="d in columns_details" :key="d.field" > 
                  <span v-if="d.field == 'product_name'">
                    <a target="_blank" :href="r['link']">{{r[d.field]}}</a>
                  </span>
                  <span v-else>
                    <span v-if="r[d.field] != ''">
                      <span>{{r[d.field]}}</span>
                    </span>
                    <span v-else>-</span>  
                  </span>
                </td>
              </tr>
            </tbody>
          </table> 
        </div>   
      </div>  
    </div>  
    <b-modal size="lg" title="Audit" v-model="showAuditModal" >
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
               {{ d.label  }} 
              <span  v-if="d.field == 'compliance_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100">?</b-btn> 
              </span>   
              <span  v-if="d.field == 'position_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'sku_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Compliance Score + Position Score + Rating Score)/3">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'rating_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Rating/5)*100">?</b-btn> 
              </span>  
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal" > 
          <tr v-for="(r,i) in rowsAudit" :key="i">
            <td v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
              {{r[d.field]}} 
            </td>
          </tr>
        </tbody>
      </table>   
      <h5 class="cust-head">Position Score</h5>
      <table id="position" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }}
            <span  v-if="d.field == 'category_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'category_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of results
                  2: if System in page 2-3 of results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of search results
                  2: if System in page 2-3 of search results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 

      <h5 class="cust-head">Compliance Score</h5>
      <table id="compliance" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }} 
            <span  v-if="d.field == 'logo'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Badges
                  2: Incorrect AMD Badges
                  3: No AMD Badges">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'image_count'">
                <b-btn class="hint" v-b-tooltip.hover title="1: 3 or more product images
                  2: 2 more product images
                  3: 0 or 1 product images">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'nomenclature'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Nomenclature
                  2: Incorrect AMD Nomenclature
                  3: No AMD Nomenclature">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'message'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Messaging
                  2: Incorrect AMD Messaging
                  3: No AMD Messaging">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 
    </b-modal>
  </div>
</template>
<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'sovdetail',
  components: { Datepicker},
  data: function () {
    return {
    	selected_website:localStorage.selected_website,
      date:{
        startDate: moment().subtract(1,'days').format('YYYY-MM-DD')
      },
      columns_details:[
        {label: 'Rank', field: 'order'},
        {label: 'Page', field: 'page'},
        {label: 'Brand', field: 'brand'},
        {label: 'Name', field: 'product_name',sortable: false},
        {label: 'Price', field: 'price',sortable: false},
        {label: 'Offer', field: 'offer',sortable: false},
        {label: 'Reviews', field: 'reviews'},
        {label: 'Ratings', field: 'ratings'}
      ],
      rows:[],
      rows_details:[],
      page:1,   
      showAuditModal: false,
      columnsAudit:[
        {label: 'SKU', field: 'sku', sortable: false},
        {label: 'Compliance Score', field:'compliance_score', sortable: false},
        {label: 'Position Score', field: 'position_score', sortable: false},
        {label: 'Rating Score', field: 'rating_score', sortable: false},
        {label: 'SKU Score', field: 'sku_score', sortable: false},
      ],
      columns_category:[
        {label: 'Category Position', field: 'category_position',sortable: false},
        {label: 'Category page position (1-3)', field: 'category_13_position',sortable: false},
        {label: 'Search Position', field: 'search_position',sortable: false},
        {label: 'Search (1-3) Position', field: 'search_13_position',sortable: false}
      ],
      columns_compliance:[
        {label: 'Product Logo', field: 'logo',sortable: false},
        {label: 'OEM Images', field: 'image_count',sortable: false},
        {label: 'Nomenclature', field: 'nomenclature',sortable: false},
        {label: 'Message', field: 'message',sortable: false}
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false
    }
  },
  mounted()
  {
    this.website_details()
  },
  methods: {
    backToSov()
    { 
      window.location = '#/sov-summary-plantronics'

    },
    showHeroChange(){
      let self = this
      $('#myTable2').DataTable().destroy();
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        if(self.isHero)
        {
          if(dataset.is_hero)
          {
            this.rows_details.push(dataset)
          }  
        }  
        else
          this.rows_details.push(dataset)
      }
      this.$nextTick(function(){
        self.initDt2()
      })  
    },
   
    openAuditModal(r){
      let self = this
      self.rowsAudit = []
      self.showAuditModal = true
      self.rowsAudit.push(r.audit)
    },
    
    format(v)
    {
      return this.$options.filters.format(v)
    },
    refresh(){
      $('#myTable2').DataTable().destroy();
      localStorage.selected_website = this.selected_website
      this.website_details()
    },
  
    website_details(){
      let self = this
      self.loader = true
      this.rows_details = []
      this.rows_details_full = []
      const url = "/api/websites/details"
      this.$http.post(url, { "website": this.selected_website,"timestamp":this.date.startDate }).then(response => {
        let resData = [
          {
            "order": 1,
            "price": "Rs 649.00",
            "offer": " Rs 1,800.00",
            "page": 1,
            "link": "https://www.amazon.in/Tangent-Lite-Magnetic-Bluetooth-Headphones/dp/B085W8CFLH/",
            "page_count": 16,
            "reviews": 6696,
            "ratings": 3.5,
            "image_count": 6,
            "product_name": "pTron Tangent Lite Bluetooth 5.0 Wireless Headphones with Hi-Fi Stereo Sound, 6Hrs Playtime, Lightweight Ergonomic Neckband, Sweat-Resistant Magnetic Earbuds, Voice Assistant & Mic - (Black)",
            "item_id": "B085W8CFLH",
            "brand": "ptron"
          },
          {
            "order": 2,
            "price": "Rs 1,424.00",
            "offer": " Rs 2,990.00",
            "page": 1,
            "link": "https://www.amazon.in/255-Bluetooth-Wireless-Earphone-Immersive/dp/B07C2VJXP4/",
            "page_count": 16,
            "reviews": 78872,
            "ratings": 3.9,
            "image_count": 6,
            "product_name": "boAt Rockerz 255 Sports in-Ear Bluetooth Neckband Earphone with Mic (Active Black)",
            "item_id": "B07C2VJXP4",
            "brand": "boat"
          },
          {
            "order": 3,
            "price": "Rs 325.00",
            "offer": " Rs 1,299.00",
            "page": 1,
            "link": "https://www.amazon.in/Techfire-HBS-730-Sweatproof-Cancellation/dp/B088R82BWT/",
            "page_count": 16,
            "reviews": 2064,
            "ratings": 3.2,
            "image_count": 6,
            "product_name": "Techfire HBS 730 Wireless Neckband Bluetooth Earphone Headset Earbud Portable Headphone Handsfree Sports Running Sweatproof Compatible Android Smartphone Noise Cancellation (HBS 730)",
            "item_id": "B088R82BWT",
            "brand": "techfire"
          },
          {
            "order": 4,
            "price": "Rs 820.00",
            "offer": " Rs 1,199.00",
            "page": 1,
            "link": "https://www.amazon.in/Zebronics-Zeb-Thunder-Bluetooth-Headphone-Input/dp/B07L8JTZ4H/",
            "page_count": 16,
            "reviews": 4954,
            "ratings": 3.7,
            "image_count": 6,
            "product_name": "Zebronics Zeb-Thunder Wireless BT Headphone Comes with 40mm Drivers, AUX Connectivity, Built in FM, Call Function, 9Hrs* Playback time and Supports Micro SD Card (Blue)",
            "item_id": "B07L8JTZ4H",
            "brand": "zebronics"
          },
          {
            "order": 5,
            "price": "Rs 379.00",
            "offer": " Rs 999.00",
            "page": 1,
            "link": "https://www.amazon.in/SKYPHR-Bluetooth-Cancellation-Technology-Smartphones/dp/B08QFV7FCY/",
            "page_count": 16,
            "reviews": 2,
            "ratings": 5,
            "image_count": 6,
            "product_name": "SKYPHR i7s TWS Wireless Bluetooth Earphone Mini Twin Portable Bluetooth Headset, with Active Noise Cancellation Technology and Charging Box for All Smartphones(White)",
            "item_id": "B08QFV7FCY",
            "brand": "skyphr"
          },
          {
            "order": 6,
            "price": "Rs 279.00",
            "offer": " Rs 499.00",
            "page": 1,
            "link": "https://www.amazon.in/Bluetooth-Wireless-Headphones-Hands-Free-Microphone/dp/B08GM6YW9Q/",
            "page_count": 16,
            "reviews": 3,
            "ratings": 3.3,
            "image_count": 3,
            "product_name": "HBS-730 Bluetooth Wireless Headphones Sport Stereo Headsets Hands-Free with Microphone and Neckband for Android and iOS Devices (Black)",
            "item_id": "B08GM6YW9Q",
            "brand": "genericc"
          },
          {
            "order": 7,
            "price": "Rs 649.00",
            "offer": " Rs 1,800.00",
            "page": 1,
            "link": "https://www.amazon.in/Tangent-Lite-Magnetic-Bluetooth-Headphones/dp/B085W7JMTB/",
            "page_count": 16,
            "reviews": 6696,
            "ratings": 3.5,
            "image_count": 6,
            "product_name": "pTron Tangent Lite Bluetooth 5.0 Wireless Headphones with Hi-Fi Stereo Sound, 6Hrs Playtime, Lightweight Ergonomic Neckband, Sweat-Resistant Magnetic Earbuds, Voice Assistant & Mic - (Black & Yellow)",
            "item_id": "B085W7JMTB",
            "brand": "ptron"
          },
          {
            "order": 8,
            "price": "Rs 1,090.00",
            "offer": " Rs 3,499.00",
            "page": 1,
            "link": "https://www.amazon.in/Rockerz-255-Pro-Technology-Resistance/dp/B082VRTF4M/",
            "page_count": 16,
            "reviews": 78872,
            "ratings": 3.9,
            "image_count": 6,
            "product_name": "boAt Rockerz 255 Pro in-Ear Bluetooth Neckband Earphone with Mic(Raging Red)",
            "item_id": "B082VRTF4M",
            "brand": "boat"
          },
          {
            "order": 9,
            "price": "Rs 849.00",
            "offer": " Rs 2,499.00",
            "page": 1,
            "link": "https://www.amazon.in/Tangentbeat-Bluetooth-Headphones-Waterproof-Cancelation/dp/B08D77XZX5/",
            "page_count": 16,
            "reviews": 2331,
            "ratings": 4.2,
            "image_count": 7,
            "product_name": "pTron Tangentbeat Bluetooth 5.0 Wireless Headphones with Deep Bass, Ergonomic Design, IPX4 Sweat/Waterproof Neckband, Magnetic Earbuds, Voice Assistant, Passive Noise Cancelation & Mic - (Black)",
            "item_id": "B08D77XZX5",
            "brand": "ptron"
          },
          {
            "order": 10,
            "price": "Rs 899.00",
            "offer": " Rs 1,899.00",
            "page": 1,
            "link": "https://www.amazon.in/pTron-Atom-Wireless-Bluetooth-Headphone/dp/B07WMBGKMQ/",
            "page_count": 16,
            "reviews": 772,
            "ratings": 3.7,
            "image_count": 6,
            "product_name": "pTron Atom in-Ear Mono Bluetooth 5.0 Wireless Headphone, Built-in Mic, Clear Calls, Snug-fit Sweatproof Earbud, Voice Assistant, Passive Noise Cancelation Earphone & Smart One-Key Control - (Black)",
            "item_id": "B07WMBGKMQ",
            "brand": "ptron"
          },
          {
            "order": 11,
            "price": "Rs 315.00",
            "offer": " Rs 2,999.00",
            "page": 1,
            "link": "https://www.amazon.in/Wireless-Bluetooth-Headphone-Sweatproof-Smartphone/dp/B08QVL7DZN/",
            "page_count": 16,
            "reviews": 4,
            "ratings": 4.2,
            "image_count": 7,
            "product_name": "SINNUX B11 Wireless Bluetooth Headset Sports Bluetooth Headphone Sweatproof & Mic with Magnet Earphone Bluetooth Headset & Mic Support for All Smartphone (Assorted Colour)",
            "item_id": "B08QVL7DZN",
            "brand": "generic"
          },
          {
            "order": 12,
            "price": "Rs 349.00",
            "offer": " Rs 999.00",
            "page": 1,
            "link": "https://www.amazon.in/CRAYOTALK-LABEL-Hands-Free-Cancellation-Smartphone/dp/B08SKFWG78/",
            "page_count": 16,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "CRAYOTALK (LABEL) Combo Pack Wireless Earphone Bluetooth Headset, HiFi Extra Bass Earphone, Hands-Free Bluetooth Earphone Noise Cancellation with Mic for iPhone & All Smartphone",
            "item_id": "B08SKFWG78",
            "brand": "crayotalk (label)"
          },
          {
            "order": 13,
            "price": "Rs 499.00",
            "offer": " Rs 2,299.00",
            "page": 1,
            "link": "https://www.amazon.in/iBall-Sporty-Smartphones-Military-Green/dp/B07VPTNJ8J/",
            "page_count": 16,
            "reviews": 1392,
            "ratings": 3.7,
            "image_count": 6,
            "product_name": "iBall EarWear Sporty Wireless Bluetooth Headset with Mic for All Smartphones (Military Green)",
            "item_id": "B07VPTNJ8J",
            "brand": "iball"
          },
          {
            "order": 14,
            "price": "Rs 499.00",
            "offer": " Rs 1,999.00",
            "page": 1,
            "link": "https://www.amazon.in/Wireless-S109-Bluetooth-AllAndroid-Smartphone/dp/B08HHDMZ29/",
            "page_count": 16,
            "reviews": 7,
            "ratings": 3.8,
            "image_count": 4,
            "product_name": "SINNUX Single Wireless 18 Hours of Calling with 1 Hour Charge S109 Bluetooth Headset with Mic Designed for AllAndroid Smartphone (Black)",
            "item_id": "B08HHDMZ29",
            "brand": "generic"
          },
          {
            "order": 15,
            "price": "Rs 1,399.00",
            "offer": " Rs 2,999.00",
            "page": 1,
            "link": "https://www.amazon.in/Infinity-Glide-120-Earphones-Sweatproof/dp/B082MDMW3X/",
            "page_count": 16,
            "reviews": 5038,
            "ratings": 3.7,
            "image_count": 6,
            "product_name": "Infinity (JBL) Glide 120 Metal in-Ear Wireless Flex Neckband with Bluetooth 5.0 and IPX5 Sweatproof (Black and Yellow)",
            "item_id": "B082MDMW3X",
            "brand": "infinity"
          },
          {
            "order": 16,
            "price": "Rs 899.00",
            "offer": " Rs 2,499.00",
            "page": 1,
            "link": "https://www.amazon.in/Moonwalk-M1-Wireless-Bluetooth-Earphones/dp/B08BY1G7N3/",
            "page_count": 16,
            "reviews": 3840,
            "ratings": 3.6,
            "image_count": 6,
            "product_name": "WeCool Moonwalk M1 True Wireless Earbuds (TWS) IPX 5 and Digital Display Charging Case, Bluetooth Earphones with Mic for Calls and HD Stereo Music",
            "item_id": "B08BY1G7N3",
            "brand": "wecool"
          },
          {
            "order": 17,
            "price": "Rs 999.00",
            "offer": " Rs 2,000.00",
            "page": 2,
            "link": "https://www.amazon.in/PTron-Bassbuds-Lite-Bluetooth-Headphones/dp/B081QXQVFM/",
            "page_count": 16,
            "reviews": 6852,
            "ratings": 3.5,
            "image_count": 6,
            "product_name": "pTron Bassbuds Lite V2 In-Ear True Wireless Bluetooth 5.0 Headphones with HiFi Deep Bass, Total 20Hrs Playtime, Ergonomic Sweatproof Earbuds, Noise Isolation, Voice Assistance & Built-in Mic - (Black)",
            "item_id": "B081QXQVFM",
            "brand": "ptron"
          },
          {
            "order": 18,
            "price": "Rs 369.00",
            "offer": " Rs 1,295.00",
            "page": 2,
            "link": "https://www.amazon.in/Techfire-Neckband-Bluetooth-Silicone-Bracelet/dp/B08JPYWN95/",
            "page_count": 16,
            "reviews": 54,
            "ratings": 3.1,
            "image_count": 6,
            "product_name": "Techfire Neckband Bluetooth Headset with Mic and Big Screen Unisex Silicone Digital LED Bracelet Band",
            "item_id": "B08JPYWN95",
            "brand": "techfire"
          },
          {
            "order": 19,
            "price": "Rs 348.00",
            "offer": " Rs 999.00",
            "page": 2,
            "link": "https://www.amazon.in/DENISIGA-Wireless-Headphone-Charging-Bluetooth/dp/B08R2TKRZH/",
            "page_count": 16,
            "reviews": 1,
            "ratings": 1,
            "image_count": 3,
            "product_name": "DENISIGA i7 TWS Twins Wireless Earbuds Sports Headphone with Charging Box Bluetooth Headset (White, in The Ear)",
            "item_id": "B08R2TKRZH",
            "brand": "riot"
          },
          {
            "order": 20,
            "price": "Rs 390.00",
            "offer": " Rs 1,999.00",
            "page": 2,
            "link": "https://www.amazon.in/Rocketkart-Bluetooth-Lightweight-Sweat-Resistant-Cancellation/dp/B08SR67S8B/",
            "page_count": 16,
            "reviews": 0,
            "ratings": 0,
            "image_count": 7,
            "product_name": "Rocketkart Bluetooth 4.2 Wireless Headphones with Hi-Fi Stereo Sound, Lightweight Ergonomic Neckband, Sweat-Resistant Magnetic Earbuds for Running & Gym, Built-in Noise Cancellation & Mic for Calling",
            "item_id": "B08SR67S8B",
            "brand": "rocketkart"
          },
          {
            "order": 21,
            "price": "Rs 549.00",
            "offer": " Rs 1,999.00",
            "page": 2,
            "link": "https://www.amazon.in/PINEAPPLE-Bluetooth-Cancellation-Technology-Smartphones/dp/B08RB4WQST/",
            "page_count": 16,
            "reviews": 0,
            "ratings": 0,
            "image_count": 5,
            "product_name": "PINEAPPLE inpods i11 TWS Wireless Bluetooth Earphone Headphone Mini Twin Portable Bluetooth Headset, with Active Noise Cancellation Technology and Charging Box for All Smartphones (White)",
            "item_id": "B08RB4WQST",
            "brand": "pineapple"
          },
          {
            "order": 22,
            "price": "Rs 1,199.00",
            "offer": " Rs 4,499.00",
            "page": 2,
            "link": "https://www.amazon.in/Boult-Audio-Curve-Sweatproof-Headphones/dp/B07LG59NPV/",
            "page_count": 16,
            "reviews": 31763,
            "ratings": 3.8,
            "image_count": 6,
            "product_name": "Boult Audio ProBass Curve Wireless Neckband Earphones with 12 Hour Battery Life & Latest Bluetooth 5.0, IPX5 Sweatproof Headphones with mic (Black)",
            "item_id": "B07LG59NPV",
            "brand": "boult audio"
          },
          {
            "order": 23,
            "price": "Rs 1,999.00",
            "offer": " Rs 2,190.00",
            "page": 2,
            "link": "https://www.amazon.in/OnePlus-Bullets-Wireless-Bass-Blue/dp/B08HLSW3Y9/",
            "page_count": 16,
            "reviews": 24378,
            "ratings": 4.2,
            "image_count": 5,
            "product_name": "OnePlus Bullets Wireless Z Bass Edition (Bass Blue)",
            "item_id": "B08HLSW3Y9",
            "brand": "oneplus"
          },
          {
            "order": 24,
            "price": "Rs 329.00",
            "offer": " Rs 999.00",
            "page": 2,
            "link": "https://www.amazon.in/Bluetooth-Headphones-Hands-Free-Earphones-Smartphones/dp/B08RC33F3Y/",
            "page_count": 16,
            "reviews": 3,
            "ratings": 4.3,
            "image_count": 7,
            "product_name": "ZENOCELL B11 Neckband Bluetooth Headphones Wireless Sport Stereo Headsets Hands-Free Earphones with Inbuilt Mic for All Smartphones & Tablets",
            "item_id": "B08RC33F3Y",
            "brand": "generic"
          },
          {
            "order": 25,
            "price": "Rs 129.00",
            "offer": " Rs 999.00",
            "page": 2,
            "link": "https://www.amazon.in/MODIK-D005-Bluetooth-Headphone-Sweatproof/dp/B08SQZCKPH/",
            "page_count": 16,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "MODIK D005 Wireless Magnet Bluetooth Earphone Headphone with Mic, Sweatproof Sports Headset, for Running and Gym, Stereo Sound with Ergonomic (Black)",
            "item_id": "B08SQZCKPH",
            "brand": "modik"
          },
          {
            "order": 26,
            "price": "Rs 399.00",
            "offer": " Rs 1,299.00",
            "page": 2,
            "link": "https://www.amazon.in/Lowfe-Wireless-Bluetooth-Headphone-Magnetic/dp/B08R8WZC2V/",
            "page_count": 16,
            "reviews": 5,
            "ratings": 1.5,
            "image_count": 6,
            "product_name": "Lowfe Combo in Ear Wireless Bluetooth Headset Headphone for Calling and Music, Round Zipper Pouch & Magnetic Wireless Bluetooth Earphone Sports Stereo Sound Support for Android/iOS Devices",
            "item_id": "B08R8WZC2V",
            "brand": "lowfe"
          },
          {
            "order": 27,
            "price": "Rs 539.00",
            "offer": " Rs 1,999.00",
            "page": 2,
            "link": "https://www.amazon.in/Titanic-Bluetooth-Neckband-Headset-Wireless/dp/B08BFGBY7W/",
            "page_count": 16,
            "reviews": 399,
            "ratings": 3.7,
            "image_count": 4,
            "product_name": "U&i Titanic Series Bluetooth Neckband Bluetooth Headset (Black, Wireless in The Ear)",
            "item_id": "B08BFGBY7W",
            "brand": "u&i"
          },
          {
            "order": 28,
            "price": "Rs 399.00",
            "offer": " Rs 999.00",
            "page": 2,
            "link": "https://www.amazon.in/TEQNEQ-Wireless-Bluetooth-Headphone-Magnetic/dp/B08RNCRBTM/",
            "page_count": 16,
            "reviews": 7,
            "ratings": 3.1,
            "image_count": 6,
            "product_name": "TEQNEQ TK09 Wireless Bluetooth Headset Headphone for Calling & Music with Magnetic Wireless Bluetooth Earphone Sports Stereo Jogger, Running, Gyming for All Android/iOS Devices (1 Year Warranty)",
            "item_id": "B08RNCRBTM",
            "brand": "teqneq"
          },
          {
            "order": 29,
            "price": "Rs 649.00",
            "offer": " Rs 2,000.00",
            "page": 2,
            "link": "https://www.amazon.in/PTron-Evo-Bluetooth-Earphone-Wireless/dp/B07S23Z9GF/",
            "page_count": 16,
            "reviews": 1492,
            "ratings": 3.6,
            "image_count": 6,
            "product_name": "pTron BassFest Evo InTunes, Magnetic in-Ear Bluetooth 5.0 Wireless Headphones, Immersive Sound with Bass, Snug-fit, Sweatproof, Lightweight, Passive Noise Canceling Earphones & Mic - (Grey and Black)",
            "item_id": "B07S23Z9GF",
            "brand": "ptron"
          },
          {
            "order": 30,
            "price": "Rs 1,799.00",
            "offer": " Rs 1,999.00",
            "page": 2,
            "link": "https://www.amazon.in/realme-RMA108-Realme-Buds-Wireless/dp/B07XJWTYM2/",
            "page_count": 16,
            "reviews": 18160,
            "ratings": 4.1,
            "image_count": 6,
            "product_name": "realme Buds Wireless in-Ear Bluetooth with mic (Yellow)",
            "item_id": "B07XJWTYM2",
            "brand": "realme"
          },
          {
            "order": 31,
            "price": "Rs 119.00",
            "offer": " Rs 999.00",
            "page": 2,
            "link": "https://www.amazon.in/MODIK-Bluetooth-Headphone-Sweatproof-Ergonomic/dp/B08T7RFHPS/",
            "page_count": 16,
            "reviews": 0,
            "ratings": 0,
            "image_count": 5,
            "product_name": "MODIK D006 Wireless Magnet Bluetooth Earphone Headphone with Mic, Sweatproof Sports Headset, for Running and Gym, Stereo Sound with Ergonomic (Black)",
            "item_id": "B08T7RFHPS",
            "brand": "modik"
          },
          {
            "order": 32,
            "price": "Rs 1,099.00",
            "offer": " Rs 1,900.00",
            "page": 2,
            "link": "https://www.amazon.in/pTron-Bassbuds-Wireless-Bluetooth-Headphones/dp/B07WSHWNH8/",
            "page_count": 16,
            "reviews": 14046,
            "ratings": 3.4,
            "image_count": 6,
            "product_name": "pTron Bassbuds in-Ear True Wireless Bluetooth 5.0 Headphones with Hi-Fi Deep Bass, 20Hrs Playtime with Case, Ergonomic Sweatproof Earbuds, Noise Isolation, Voice Assistance & Built-in Mic - (Black)",
            "item_id": "B07WSHWNH8",
            "brand": "ptron"
          },
          {
            "order": 33,
            "price": "Rs 1,299.00",
            "offer": " Rs 1,899.00",
            "page": 3,
            "link": "https://www.amazon.in/Jabra-Bluetooth-Headset-Hands-Free-Conversations/dp/B07FMPRTX3/",
            "page_count": 16,
            "reviews": 2436,
            "ratings": 3.7,
            "image_count": 5,
            "product_name": "Jabra Talk 15 Bluetooth Headset for Hands-Free Calls with Clear Conversations and Ease of Use (Black)",
            "item_id": "B07FMPRTX3",
            "brand": "jabra"
          },
          {
            "order": 34,
            "price": "Rs 357.00",
            "offer": " Rs 999.00",
            "page": 3,
            "link": "https://www.amazon.in/RIOT-Accessories-Headphone-Earphone-Bluetooth/dp/B08R2SVZZJ/",
            "page_count": 16,
            "reviews": 0,
            "ratings": 0,
            "image_count": 5,
            "product_name": "RIOT Accessories I7S TWS Headphone Twins Earphone Stereo Bluetooth Headset (White, in The Ear)",
            "item_id": "B08R2SVZZJ",
            "brand": "riot"
          },
          {
            "order": 35,
            "price": "Rs 799.00",
            "offer": " Rs 1,295.00",
            "page": 3,
            "link": "https://www.amazon.in/Techfire-Bluetooth-Wireless-Earphones-Neckband/dp/B08JPX1R4P/",
            "page_count": 16,
            "reviews": 45,
            "ratings": 3.4,
            "image_count": 6,
            "product_name": "Techfire u Level Bluetooth Wireless Earphones 4.1 with Mic in-Ear Stereo Sport Neckband Headsets with Back Button for All Andriod & iOS (Level U Bluetooth)",
            "item_id": "B08JPX1R4P",
            "brand": "techfire"
          },
          {
            "order": 36,
            "price": "Rs 489.00",
            "offer": " Rs 1,599.00",
            "page": 3,
            "link": "https://www.amazon.in/Earbuds-Headphone-Charging-Bluetooth-Headset/dp/B08FNZH53G/",
            "page_count": 16,
            "reviews": 1,
            "ratings": 5,
            "image_count": 7,
            "product_name": "BRONET i7S Sports Earbuds Headphone(Dual L/R) BT with Charging Box Bluetooth Headset (White, in The Ear)",
            "item_id": "B08FNZH53G",
            "brand": null
          },
          {
            "order": 37,
            "price": "Rs 379.00",
            "offer": " Rs 899.00",
            "page": 3,
            "link": "https://www.amazon.in/TEVOTALK-Wireless-Bluetooth-Headphone-Compatible/dp/B08PBXLT4M/",
            "page_count": 16,
            "reviews": 9,
            "ratings": 3,
            "image_count": 6,
            "product_name": "TEVOTALK Combo Wireless Magnet Bluetooth Earphone Headphone with Mic, Stereo Sound with Music Sports Wireless Bluetooth Headset Compatible with All Android and Apple Phone Devices",
            "item_id": "B08PBXLT4M",
            "brand": "tevotalk"
          },
          {
            "order": 38,
            "price": "Rs 399.00",
            "offer": " Rs 800.00",
            "page": 3,
            "link": "https://www.amazon.in/Blue-Birds-Wireless-Bluetooth-Headphone/dp/B08RNMHL58/",
            "page_count": 16,
            "reviews": 1,
            "ratings": 3,
            "image_count": 6,
            "product_name": "Blue Birds Wireless Bluetooth Earphone Headset Earbud Portable Headphone (White)",
            "item_id": "B08RNMHL58",
            "brand": "blue birds"
          },
          {
            "order": 39,
            "price": "Rs 1,299.00",
            "offer": " Rs 4,499.00",
            "page": 3,
            "link": "https://www.amazon.in/Boult-Audio-Curve-Sweatproof-Headphones/dp/B07MK2H78S/",
            "page_count": 16,
            "reviews": 31763,
            "ratings": 3.8,
            "image_count": 6,
            "product_name": "Boult Audio ProBass Curve Wireless Neckband Earphones with 12 Hour Battery Life & Latest Bluetooth 5.0, IPX5 Sweatproof Headphones with mic (Blue)",
            "item_id": "B07MK2H78S",
            "brand": "boult audio"
          },
          {
            "order": 40,
            "price": "Rs 329.00",
            "offer": " Rs 999.00",
            "page": 3,
            "link": "https://www.amazon.in/TEQNEQ-Wireless-Bluetooth-Headphone-Compatible/dp/B08R3MF3V9/",
            "page_count": 16,
            "reviews": 0,
            "ratings": 0,
            "image_count": 7,
            "product_name": "TEQNEQ Combo Wireless Magnet Bluetooth Earphone Headphone with Mic, Stereo Sound with Music Sports Wireless Bluetooth Headset Compatible with All Android and Apple Phone Devices",
            "item_id": "B08R3MF3V9",
            "brand": "teqneq"
          },
          {
            "order": 41,
            "price": "Rs 499.00",
            "offer": " Rs 1,299.00",
            "page": 3,
            "link": "https://www.amazon.in/Frittle-Wireless-Portable-Bluetooth-Compatible/dp/B089W973PQ/",
            "page_count": 16,
            "reviews": 43,
            "ratings": 3.5,
            "image_count": 6,
            "product_name": "Frittle HJ46 SH12 Wireless Portable Bluetooth Headset with High Bass Sound Quality, SD Card Slot for Music & Calling Control Compatible with All Devices",
            "item_id": "B089W973PQ",
            "brand": "frittle"
          },
          {
            "order": 42,
            "price": "Rs 1,099.00",
            "offer": " Rs 1,425.00",
            "page": 3,
            "link": "https://www.amazon.in/iBall-Earwear-Bluetooth-Handsfree-Microphone/dp/B07GSY95GZ/",
            "page_count": 16,
            "reviews": 416,
            "ratings": 3.7,
            "image_count": 5,
            "product_name": "iBall Mini Earwear A9 Bluetooth Handsfree with Microphone (Black)",
            "item_id": "B07GSY95GZ",
            "brand": "iball"
          },
          {
            "order": 43,
            "price": "Rs 2,399.00",
            "offer": " Rs 2,990.00",
            "page": 3,
            "link": "https://www.amazon.in/Samsung-EO-BG920BBEGIN-Bluetooth-Headphones-Black-Sapphire/dp/B01A31SHF0/",
            "page_count": 16,
            "reviews": 11184,
            "ratings": 3.6,
            "image_count": 6,
            "product_name": "Samsung Original Level U Bluetooth Wireless in-Ear Headphones (Black and Sapphire)",
            "item_id": "B01A31SHF0",
            "brand": "samsung"
          },
          {
            "order": 44,
            "price": "Rs 264.00",
            "offer": " Rs 999.00",
            "page": 3,
            "link": "https://www.amazon.in/Wireless-Bluetooth-Cancellation-Technology-Smartphones/dp/B08KQLCNQR/",
            "page_count": 16,
            "reviews": 19,
            "ratings": 3.2,
            "image_count": 5,
            "product_name": "l7s TWS Wireless Bluetooth Earphone Portable Bluetooth Headset, with Active Noise Cancellation Technology and Charging Box for All Smartphones (White)",
            "item_id": "B08KQLCNQR",
            "brand": "generic"
          },
          {
            "order": 45,
            "price": "Rs 1,424.00",
            "offer": " Rs 2,990.00",
            "page": 3,
            "link": "https://www.amazon.in/255-Bluetooth-Wireless-Earphone-Immersive/dp/B07C2VJFDW/",
            "page_count": 16,
            "reviews": 78873,
            "ratings": 3.9,
            "image_count": 6,
            "product_name": "boAt Rockerz 255 Sports in-Ear Bluetooth Neckband Earphone with Mic(Neon)",
            "item_id": "B07C2VJFDW",
            "brand": "boat"
          },
          {
            "order": 46,
            "price": "Rs 319.00",
            "offer": " Rs 999.00",
            "page": 3,
            "link": "https://www.amazon.in/esuav-Bluetooth-Cancelling-Compatible-Smartphones/dp/B08NYLS2FD/",
            "page_count": 16,
            "reviews": 0,
            "ratings": 0,
            "image_count": 7,
            "product_name": "esuav B11 Bluetooth Headset Magnet Wireless Stereo Earphones Bluetooth V4.1 with Mic Noise Cancelling Headsets Compatible with All Android Smartphones (Assorted Colour)",
            "item_id": "B08NYLS2FD",
            "brand": "esuav"
          },
          {
            "order": 47,
            "price": "Rs 362.00",
            "offer": " Rs 999.00",
            "page": 3,
            "link": "https://www.amazon.in/RANDOMER-Headphone-Earphone-Bluetooth-Headset/dp/B08QFJSB9G/",
            "page_count": 16,
            "reviews": 1,
            "ratings": 5,
            "image_count": 5,
            "product_name": "RANDOMER SH12 TWS Headphone Twins Earphone Stereo Bluetooth Headset (White, in The Ear)",
            "item_id": "B08QFJSB9G",
            "brand": "randomer"
          },
          {
            "order": 48,
            "price": "Rs 780.00",
            "offer": " Rs 2,300.00",
            "page": 3,
            "link": "https://www.amazon.in/GROSTAR-Bluetooth-Wireless-Earphones-Smartphones/dp/B08NX4M2GB/",
            "page_count": 16,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "GROSTAR u Level Bluetooth Wireless Earphones 4.1 with Mic in-Ear Stereo Sport Neckband Headsets with Back Button for All Andriod & iOS Smartphones",
            "item_id": "B08NX4M2GB",
            "brand": "grostar"
          }
        ]
        for (let [idx, ds] of  resData.entries())
        {
          self.rows_details.push(ds)
          self.rows_details_full.push(ds)
        }
        self.loader = false
        self.$nextTick(function(){
          self.initDt2()
        })  
      
      }, err => {
        self.loader = false
      });
    },

    changeCustomDate(){
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
    },
    initDt2(){
      let self = this
      $('#myTable2').DataTable({
        initComplete: function () {
          this.api().columns().every( function () {
              var column = this;
              var select = $("<select><option value=''>All</option></select>")
                  .appendTo( $(column.footer()).empty() )
                  .on( 'change', function () {
                      var val = $.fn.dataTable.util.escapeRegex(
                          $(this).val()
                      );    
                      column
                          .search( val ? '^'+val+'$' : '', true, false )
                          .draw();
                  } );
              let arr = []    
              let sortedArr = []
              column.data().unique().sort().each( function ( d, j ) {
                var myVal = $(d).text()
                arr.push(myVal)
              } ); 
                
              sortedArr = arr.sort((a, b) => a.localeCompare(b, navigator.languages[0] || navigator.language, {numeric: true, ignorePunctuation: true}))
              for (let [idx, ds] of sortedArr.entries())
              {
                select.append( "<option value='"+ds+"'>"+ds+"</option>" )
              } 
          } );
        }
      });
    }
  }
}

</script>

<style scoped>

.custom-table
{
  padding: 10px;
  margin:10px;
}

.markitamd
{
  background-color:#ffb9b9!important
}
.markitintel
{
  background-color:#c7e0ff!important;
}
.markitsnap
{
  background-color:#ffd0f5 !important
}
.markitna
{
  background-color:#edf2fb!important
}
.markittek
{
  background-color:#fff0ce!important
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #533a79;
    margin-bottom: 0;
    line-height: 31px;
}
.listing-custom
{
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}
.hint
{
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
} 
.amd-legend
{
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index:999
}
.amd-legend i
{
  
  width: fit-content;
}
.amd-legend span
{
    padding-left: 4px;
    font-size: 12px;
}
.legending
{
  display: inline-block;
  margin-right: 19px;
}
#avgTable th, #avgTable td
{
  border:1px solid #c8ced3!important;
  text-align:left;
  font-size:14px
}
.mycols:first-child
{
 padding-right:2px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
</style>
